import { NavigateNext } from '@mui/icons-material'

import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useController } from '../../../hooks/useController'
import { useControllerActions } from '../../../hooks/useControllerActions'
import { useTexts } from '../../../useTexts'

type Props = {
  acknowledgeModal: () => void
}

export function OperationalWarningFooter(props: Props) {
  const { acknowledgeModal } = props
  const texts = useTexts()

  const { navigateToTerritorySettings, getStorageTips } = useControllerActions()
  const { status } = useController()

  const submitting = status === 'submitting'

  const onNavigate = () => {
    acknowledgeModal()
    navigateToTerritorySettings()
  }

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          Icon={<NavigateNext />}
          testid="modal-primary-button"
          data-trackid="modal-primary-button"
          disabled={submitting}
          loading={submitting}
          onClick={getStorageTips}
          variant="contained"
        >
          {texts.getStorageTipsButton}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton
          onClick={onNavigate}
          disabled={submitting}
          loading={submitting}
          testid="modal-secondary-button"
          data-trackid="modal-secondary-button"
        >
          {texts.navigateToTerritorySettingsButton}
        </ModalFooterButton>
      }
    />
  )
}
